export default __webpack_public_path__ + "static/media/image-grid-search.10df9f4e.png";